import { postQrLogin } from 'api';
import { debounceSecond } from 'assets/constant';
import { SpinnerLoading } from 'components/common';
import { debounce } from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { useSearchParams, useParams} from 'react-router-dom';

const QrType = {
  SESSION_1: '[1주차 1차시]',
  SESSION_2: '[1주차 2차시]',
  SESSION_3: '[1주차 3차시]',
  SESSION_4: '[2주차 1차시]',
  SESSION_5: '[2주차 2차시]',
  SESSION_6: '[2주차 3차시]',
  SESSION_7: '[3주차 1차시]',
  SESSION_8: '[3주차 2차시]',
  SESSION_9: '[3주차 3차시]',
  SESSION_10: '[4주차 1차시]',
  SESSION_11: '[4주차 2차시]',
  SESSION_12: '[4주차 3차시]',
  SESSION_13: '[5주차 1차시]',
  SESSION_14: '[5주차 2차시]',
  SESSION_15: '[5주차 3차시]',
  SESSION_16: '[6주차 1차시]',
  SESSION_17: '[6주차 2차시]',
  SESSION_18: '[6주차 3차시]',
  SESSION_19: '[7주차 1차시]',
  SESSION_20: '[7주차 2차시]',
  SESSION_21: '[7주차 3차시]',
  SESSION_22: '[8주차 1차시]',
  SESSION_23: '[8주차 2차시]',
  SESSION_24: '[8주차 3차시]',
  SESSION_25: '[9주차 1차시]',
  SESSION_26: '[9주차 2차시]',
  SESSION_27: '[9주차 3차시]',
  SESSION_28: '[10주차 1차시]',
  SESSION_29: '[10주차 2차시]',
  SESSION_30: '[10주차 3차시]',
  SESSION_31: '[11주차 1차시]',
  SESSION_32: '[11주차 2차시]',
  SESSION_33: '[11주차 3차시]',
  SESSION_34: '[12주차 1차시]',
  SESSION_35: '[12주차 2차시]',
  SESSION_36: '[12주차 3차시]',
  SESSION_37: '[13주차 1차시]',
  SESSION_38: '[13주차 2차시]',
  SESSION_39: '[13주차 3차시]',
  SESSION_40: '[14주차 1차시]',
  SESSION_41: '[14주차 2차시]',
  SESSION_42: '[14주차 3차시]',
  SESSION_43: '[15주차 1차시]',
  SESSION_44: '[15주차 2차시]',
  SESSION_45: '[15주차 3차시]',
};

export function QrLoginPage() {
  const autoFocusInput = useRef(null);
  const [verification, setVerification] = useState(false);
  const [userId, setUserId] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [searchParams] = useSearchParams();

  const {qrType} = useParams();
  const settingId = searchParams.get('settingId');
  const debounceHandleSubmit = debounce(async () => {
    const loginData = {
      loginId: userId,
      qrType: qrType,
      settingId: settingId,
    };

    setIsLoading(true);
    try {
      const result = await postQrLogin(loginData);
      resetLogin();
      // 에러메세지를 반환하면 에러메세지 출력
      if (!result && !result.status !== 200) {
        setIsLoading(false);
        return;
      }
      if (result.data.errorCode && result.data.errorCode === 'U001') {
        setErrorMsg('학번을 확인해주세요');
        alert('학번을 확인해주세요');
        setIsLoading(false);
        return setVerification(true);
      }
      if (result.data.errorCode && result.data.errorCode === 'QR001') {
        setErrorMsg('이전에 출석한 내역이 있습니다.');
        setIsLoading(false);
        return setVerification(true);
      }
      if (result.data.errorCode && result.data.errorCode === 'QR002') {
        alert('출석기간이 종료되었습니다.');
        setIsLoading(false);
        return;
      }
      if (result.data.errorCode && result.data.errorCode === 'QR006') {
        alert('출석기간이 아닙니다.');
        setIsLoading(false);
        return;
      }
      if (result.data.errorCode && result.data.errorCode === 'QR007') {
        alert('만료된 QR입니다. 최신 QR을 사용해주세요.');
        setIsLoading(false);
        return;
      }
      if(result.data.errorCode && result.data.errorCode === 'C002'){
        alert('수강하고 있는 과목이 아닙니다.');
        setIsLoading(false);
        return;
      }

      setVerification(false);
      setIsLoading(false);
      alert(result.data.message || '출석 확인이 완료되었습니다.');
      resetLogin();
    } catch (error) {
      console.error('error', error);
      setIsLoading(false);
    }
  }, debounceSecond);

  const onSubmit = (e) => {
    if (userId === '' || userId === null) {
      alert('학번을 입력해주세요.');
      return;
    }
    e.preventDefault();
    debounceHandleSubmit();
  };

  const resetLogin = () => {
    setUserId('');
  };

  useEffect(() => {
    autoFocusInput.current.focus();
    return () => {
      setVerification(null);
    };
  }, []);

  return (
    <>
      <main id='qrLoginPage'>
        <form onSubmit={onSubmit} className='login-align' style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
          <div className='d-flex justify-content-center'>
            <img src='/assets/img/login_logo.png' alt='' id='qr-login-img' />
          </div>
          <div id='qr-login-card-wrapper'>
            <label className='qr-main-title m-0 qr-point'>
              KBU 성공전략 <span className='qr-sub'>QR 출석</span>
            </label>
            <div className='card' id='qr-login-card'>
              <div className='col-12'>
                <div className='d-flex align-items-center mb-2'>
                  <label className='qr-login-title m-0'>출석</label>
                </div>
                <div className='d-flex align-items-center mb-2'>
                  <label className='qr-login-body qr-point m-0'>
                    {QrType[qrType]}
                    {/* {qrInfo.number && ` (행사부스 ${qrInfo.number})`} */}
                  </label>
                </div>
              </div>
              <div className='qr-divider'></div>
              <div onSubmit={onSubmit} className='row g-3 needs-validation'>
                <div className='col-12'>
                  <div className='d-flex align-items-center mb-2'>
                    <label htmlFor='yourUsername' className='qr-login-title qr-primary m-0'>
                      학번
                    </label>
                    <p className='fz-12 text-center danger-redText ms-3'>{verification && errorMsg}</p>
                  </div>
                  <p className='qr-helper-text qr-secondary'>
                    출석체크를 위해 <span className='qr-point'>본인 학번</span>을 입력해주세요
                  </p>
                  <div className='input-group has-validation'>
                    <input
                      type='text'
                      name='username'
                      className='form-control'
                      id='yourUsername'
                      value={userId}
                      onChange={(e) => setUserId(e.target.value.trimStart())}
                      required
                      ref={autoFocusInput}
                      placeholder='학번을 입력해주세요'
                    />
                    <div className='invalid-feedback'>학번을 입력해주세요</div>
                  </div>
                </div>
              </div>
            </div>
            <button disabled={isLoading} className='w-100 qr-login-btn qr-login-btn' type='submit'>
              출석 확인
            </button>
          </div>
          <>{isLoading && <SpinnerLoading />}</>
        </form>
      </main>
    </>
  );
}
